<template>
  <div class="article-three-images-container" :class="containerClasses">
    <div class="article-three-images" :class="classes">
      <div v-if="productHandleTwo" class="TileContainer">
        <AddFromPhoto
          :product-handle="productHandleTwo"
          :image-url="imageOne"
        />
      </div>
      <div v-else class="ImageOneContainer">
        <Picture :images="imageOne" />
        <div v-if="handle" class="handle">{{ handle }}</div>
      </div>
      <div v-if="productHandle" class="TileContainer">
        <AddFromPhoto :product-handle="productHandle" :image-url="imageTwo" />
      </div>
      <div v-else class="ImageOneContainer">
        <Picture :images="imageTwo" />
      </div>
      <div v-if="productHandle2" class="TileContainer">
        <AddFromPhoto
          :product-handle="productHandle2"
          :image-url="imageThree"
        />
      </div>
      <div v-else class="ImageOneContainer">
        <Picture :images="imageThree" />
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import AddFromPhoto from "@/components/AddFromPhoto.vue";
export default {
  name: "ArticleThreeImages",
  components: {
    Picture,
    AddFromPhoto,
  },
  props: {
    imageOne: {
      type: Object,
      required: true,
    },
    imageTwo: {
      type: Object,
      required: true,
    },
    imageThree: {
      type: Object,
      required: true,
    },
    productHandleTwo: {
      type: String,
      default: null,
    },
    productHandle: {
      type: String,
      default: null,
    },
    productHandle2: {
      type: String,
      default: null,
    },
    block: {
      type: Boolean,
      default: false,
    },
    block2px: {
      type: Boolean,
      default: false,
    },
    split: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Boolean,
      default: false,
    },
    handle: {
      type: String,
      default: null,
    },
    withText: {
      type: Boolean,
      default: false,
    },
    wideCenterImage: {
      type: Boolean,
      default: false,
    },
    mobileStacked: {
      type: Boolean,
      default: false,
    },
    backgroundBlack: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    containerClasses() {
      return {
        "article-three-images-container--block": this.block,
        "article-three-images-container--block2px": this.block2px,
        "article-three-images-container--withText": this.withText,
        "article-three-images--split": this.split,
        "article-three-images-container--background-black":
          this.backgroundBlack,
      };
    },
    classes() {
      return {
        "article-three-images--split": this.split,
        "article-three-images--step": this.step,
        "article-three-images--mobileStacked": this.mobileStacked,
        "article-three-images--wide-center-image": this.wideCenterImage,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.article-three-images-container {
  padding: 0 0 60px;

  @include respond-above(md) {
    grid-template-columns: repeat(3, 1fr);
    padding: 0 0 80px;
    margin: 0 auto 20px;
    max-width: 1600px;
  }

  &--block {
    padding: 0 0 2px;

    @include respond-above(md) {
      padding: 0;
    }
  }

  &--block2px {
    padding: 0 0 2px;
    margin: 0 20px;
  }

  &--background-black {
    @include respond-above(md) {
      margin: 0 auto;
      padding: 0 20px;
      .article-three-images {
        background-color: #000000;
      }
    }
  }

  &--withText {
    margin: 0 auto 20px;
  }

  &:deep(.picture__wrapper) {
    display: block;
  }
}
.article-three-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 2px;
  column-gap: 2px;

  @include respond-above(md) {
    grid-template-columns: repeat(3, 1fr);
    column-gap: 2px;
    margin: 0 auto;
    max-width: 1600px;
    row-gap: 0;
  }

  &--split {
    column-gap: 2px;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 0;

    @include respond-above(md) {
      column-gap: 20px;
    }
  }

  &--mobileStacked {
    display: flex;
    flex-direction: column;
    column-gap: 2px;
    row-gap: 2px;
  }

  &--step {
    @include respond-above(md) {
      column-gap: 40px;
      .ImageOneContainer {
        margin: 150px 0 0 0;
      }
    }
  }

  &--wide-center-image {
    @include respond-above(md) {
      grid-template-columns: 1fr 1.78fr 1fr;
    }
  }
}

.ImageOneContainer {
  position: relative;
  .handle {
    position: absolute;
    bottom: 20px;
    left: 20px;
    color: $color-white;
  }
}
</style>
